export default "__VITE_ASSET__DKZnUK6H__"